import React, { useState, useRef, useEffect, useCallback } from 'react';
import { Button, Form, Dropdown } from "semantic-ui-react";
import {
  Container,
  Title,
  Input,
  Label,
  Field
} from './styles';

import { Link, withRouter } from "react-router-dom";
import AdminMenu from "../../../../../components/Admin/MenuDetalhes/AdminMenu";
import SignatureEditor from '../../../../../components/Admin/Certificado/SignatureEditor';
import { producaov2 as api } from '../../../../../services/apis';
import swal from 'sweetalert';
import * as yup from 'yup';

const EditarCertificado = props => {
  const [curso, setCurso] = useState('');
  const [cursosOptions, setCursosOptions] = useState([]);
  const [cursoSearch, setCursoSearch] = useState('');
  const [layout, setLayout] = useState({
    id: 0,
    title: "",
    qrcode_color: "#ffffff",
    fonte: "monserrat",
    qrcode_dim: "300x300",
    qrcode_loc: "26.50,17.82,2.05,2.05",
    nome_loc: "1.32,9.00,27.05,2.05",
    iconcurso_loc: "23.55,17.75,2.38,2.33",
    assinaturavoitto_loc: "5.02,15.63,7.12,1.58",
    assinaturaconsultor_loc: "17.85,15.68,7.12,1.58",
    descricao_loc: "2.19,11.10,25.63,1.89",
    fundo_loc: "0.00,0.00,29.57,20.86",
    fundo: "",
    cert_w: "29.7",
    cert_h: "21"
  });
  const [layoutOptions, setLayoutOptions] = useState([]);
  const [consultor, setConsultor] = useState(null);
  const [consultorOptions, setConsultorOptions] = useState([]);
  const [consultores, setConsultores] = useState(null);
  const [consultoresOptions, setConsultoresOptions] = useState([]);
  const [assinaturas, setAssinaturas] = useState([]);

  useEffect(() => {
    const id = props.match.params.id;

    api
      .get(`certificados/templates/${id}`)
      .then(res => {
        const { id_curso, layout, consultores } = res.data;
        const assinaturas = JSON.parse(consultores);


        api.get(`cursos-simplelist?search=${id_curso}&limit=15`).then(res => {
          if (res.data.length > 0) {
            const options = res.data.map((course, index) => ({ key: index, text: `[${course.id}] ${course.curso}`, value: course.id }))
            setCursosOptions(options);
            setCurso(id_curso);
            setCursoSearch(id_curso);
            return;
          }
          setCursosOptions([]);
        });


        api
          .get('layout-certificados')
          .then(res => {
            const newLayoutOptions = res.data.map(layout => ({ key: layout.id, value: { id: layout.id, ...JSON.parse(layout.json) }, text: layout.titulo }));
            const layoutObject = newLayoutOptions.find(l => l.value.id === layout).value;

            setLayoutOptions(newLayoutOptions);
            setLayout(layoutObject);
          })
          .catch(err => {
            console.error(err);
          });

        api
          .get('consultor?all==1')
          .then(res => {
            const newConsultoresOptions = res.data.map(consultor => ({ key: consultor.id, value: consultor.id, text: consultor.nome }));
            const newConsultorOptions = newConsultoresOptions.filter(option => assinaturas.map(({ id }) => id).includes(option.value));
            setConsultorOptions(newConsultorOptions);
            setConsultores(assinaturas.map(({ id }) => id));
            setConsultoresOptions(newConsultoresOptions);
          })
          .catch(err => {
            console.error(err);
          });

        setAssinaturas(assinaturas);
        setConsultor(assinaturas[0].id)
      })
      .catch(err => {
        console.error(err);
        props.history.push('/admin/ead/certificados/templates');
      })
  }, []);

  useEffect(() => {
    api
      .get('layout-certificados')
      .then(res => {
        const newLayoutOptions = res.data.map(layout => ({ key: layout.id, value: { id: layout.id, ...JSON.parse(layout.json) }, text: layout.titulo }));
        setLayoutOptions(newLayoutOptions);
      })
      .catch(err => {
        console.error(err);
      });

    api
      .get('consultor?all==1')
      .then(res => {
        const newConsultorOptions = res.data.map(consultor => ({ key: consultor.id, value: consultor.id, text: consultor.nome }));
        setConsultoresOptions(newConsultorOptions);
      })
      .catch(err => {
        console.error(err);
      });
  }, []);

  const handleLayoutChange = useCallback((e, { value }) => {
    setLayout(value);
  }, []);

  const handleConsultorChange = useCallback((e, { value }) => {
    setConsultor(value);
  }, []);

  const handleConsultoresChange = useCallback((e, { options, value }) => {
    const newConsultorOptions = options.filter(option => value.includes(option.value));
    const newAssinaturas = value.map(v => ({ id: v, margin_x: '0', margin_y: '0', width: 'auto', height: 'auto' }))
    setConsultorOptions(newConsultorOptions);
    setConsultores(value);
    setAssinaturas(newAssinaturas);
  }, []);

  const handleCursoChange = useCallback((e, { options, value }) => {
    const text = options.find(option => option.value === value).text;

    setCurso(value);
    setCursoSearch(text);
  }, []);

  const handleCursoSearchChange = useCallback((e) => {
    const search = e.target.value;

    setCursoSearch(search);

    api.get(`cursos-simplelist?search=${search}&limit=15`).then(res => {
      if (res.data.length > 0) {
        const options = res.data.map((course, index) => ({ key: index, text: `[${course.id}] ${course.curso}`, value: course.id }))
        setCursosOptions(options);
        return;
      }
      setCursosOptions([]);
    });
  });

  const handleAssinaturaChange = useCallback((e) => {
    const { name, value } = e.target;
    const index = assinaturas.map((assinatura, i) => assinatura.id === consultor ? i : -1).filter(i => i !== -1)[0];
    const newAssinaturas = [...assinaturas];
    const assinatura = newAssinaturas[index];
    assinatura[name] = value;
    newAssinaturas[index] = { ...assinatura };
    setAssinaturas(newAssinaturas);
  }, [assinaturas, consultor]);

  const handleSubmit = useCallback(e => {
    e.preventDefault();

    const id = props.match.params.id;

    const payload = {
      id_curso: curso,
      layout: layout?.id || 0,
      consultores: assinaturas
    }

    api
      .put(`certificados/templates/${id}`, payload)
      .then(res => {
        swal('Sucesso !', 'Modificador de assinaturas foi editado', 'success');
      })
      .catch(err => {
        console.error(err);
        swal('Ops !', 'Houve um erro na edição do modificador de assinaturas', 'error');
      });
  }, [curso, layout, assinaturas]);

  return (
    <>
      <AdminMenu />
      <Container>
        <Title>Edição de assinatura de consultor</Title>

        <Form>
          <Form.Group widths="equal">
            <Form.Field>
              <label>Curso</label>
              <Dropdown
                placeholder="Busque pelo ID ou pelo nome do curso"
                fluid
                search
                selection
                options={cursosOptions}
                onChange={handleCursoChange}
                searchQuery={cursoSearch}
                onSearchChange={handleCursoSearchChange}
                value={curso}
              />
            </Form.Field>
          </Form.Group>
          <Form.Group widths="equal">
            <Form.Field>
              <label>Layout</label>
              <Dropdown
                placeholder="Busque pelo layout"
                fluid
                search
                selection
                options={layoutOptions}
                onChange={handleLayoutChange}
                value={layout}
              />
            </Form.Field>
          </Form.Group>
          <Form.Group widths="equal">
            <Form.Field>
              <label>Opções de Consultores</label>
              <Dropdown
                placeholder="Busque pelo layout"
                fluid
                search
                selection
                multiple
                options={consultoresOptions}
                onChange={handleConsultoresChange}
                value={consultores}
              />
            </Form.Field>
          </Form.Group>

          <Form.Group widths="equal">
            <Form.Field>
              <label>Consultores</label>
              <Dropdown
                placeholder="Busque pelo consultor relacionado a este curso"
                fluid
                search
                selection
                options={consultorOptions}
                onChange={handleConsultorChange}
                value={consultor}
              />
            </Form.Field>
          </Form.Group>

          {
            assinaturas?.length && assinaturas.find(({ id }) => id === consultor) ? <Form.Group>
              <Field>
                <Label>Margin Y (px)</Label>
                <Input
                  name="margin_y"
                  suffix="px"
                  value={assinaturas.find(({ id }) => id === consultor).margin_y}
                  onChange={handleAssinaturaChange} />
              </Field>

              <Field>
                <Label>Margin X (px)</Label>
                <Input
                  name="margin_x"
                  value={assinaturas.find(({ id }) => id === consultor).margin_x}
                  onChange={handleAssinaturaChange} />
              </Field>

              <Field>
                <Label>Width (% | auto)</Label>
                <Input
                  name="width"
                  value={assinaturas.find(({ id }) => id === consultor).width}
                  onChange={handleAssinaturaChange} />
              </Field>

              <Field>
                <Label>Height (% | auto)</Label>
                <Input
                  name="height"
                  value={assinaturas.find(({ id }) => id === consultor).height}
                  onChange={handleAssinaturaChange} />
              </Field>
            </Form.Group>
              : null
          }

          {
            layout && assinaturas?.length && assinaturas.find(({ id }) => id === consultor) ? <SignatureEditor
              certificado={layout}
              setCertificado={setLayout}
              assinatura={assinaturas.find(({ id }) => id === consultor)}
              display
            /> : null
          }

          <Form.Group>
            <Form.Field>
              <Button onClick={handleSubmit}>
                Salvar
              </Button>
            </Form.Field>
            <Link to="/admin/ead/certificados">
              <Button color="secondary">Cancelar</Button>
            </Link>
          </Form.Group>
        </Form>
      </Container>
    </>
  )
}

export default withRouter(EditarCertificado);